import s from './teacher-education.module.scss'
import { format } from 'date-fns'
import { IconRosetteFilled, IconAlertHexagon, IconCheck } from '@tabler/icons-react';

export const TeacherEducation = ({teacher}) => {
	if (!teacher) return null

	const hasEducation = teacher?.education?.length > 0 && teacher?.education?.[0]?.organization?.length > 0

	return (
		<div className={s.education}>
			<div className={s.title}>Образование</div>

			{hasEducation ? (
				<div className={s.educationList}>
					{teacher?.education.map((e) => (
						<div key={e} className={s.educationCard}>
							<div className={s.verifyWrapper}>
								<div className={s.verifyIconWrapper}>
									<IconRosetteFilled className={s.verifyIcon}/>
									<IconCheck className={s.verifyIconCheck}/>
								</div>
								{e?.started ? <span className={s.verifyDate}>{format(e?.started, 'dd.MM.yyyy')}</span> : <span className={s.verifyDate}>Подтверждено</span>}
							</div>
							<span className={s.educationContent}>
								{e?.organization}
							</span>
							{e?.faculty && <span className={s.educationCaption}>{e?.faculty}</span>}
						</div>
					))}
				</div>
			) : (
				<div className={s.placeholder}>
					<IconAlertHexagon size={20} className={s.placeholderIcon} />
					<span className={s.placeholderText}>Преподаватель еще не добавил образование</span>
				</div>
			)}
		</div>
	)
}
